import React from 'react';
import * as S from './OperationsTableSkeleton.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface OperationsTableSkeletonProps {
  rowsCount?: number;
  hasHeader?: boolean;
  hasContainer?: boolean;
}

const DEFAULT_ROWS_COUNT = 8;

export function OperationsTableSkeleton({
  rowsCount = DEFAULT_ROWS_COUNT,
  hasHeader = true,
  hasContainer = true,
}: OperationsTableSkeletonProps) {
  const content = (
    <>
      {hasHeader && (
        <S.Header>
          <SkeletonLoader width="80%" height={18} borderRadius={7} />
          <SkeletonLoader width="70%" height={18} borderRadius={7} />
          <SkeletonLoader width="60%" height={18} borderRadius={7} />
          <SkeletonLoader width="70%" height={18} borderRadius={7} />
          <SkeletonLoader width="60%" height={18} borderRadius={7} />
          <SkeletonLoader width={14} height={14} borderRadius={7} />
        </S.Header>
      )}

      {Array.from({ length: rowsCount }).map((_, index) => (
        <S.Row key={index}>
          <SkeletonLoader width="90%" height={18} borderRadius={7} />
          <SkeletonLoader width="80%" height={18} borderRadius={7} />
          <SkeletonLoader width="70%" height={18} borderRadius={7} />
          <SkeletonLoader width="80%" height={18} borderRadius={7} />
          <SkeletonLoader width="90%" height={18} borderRadius={7} />
          <SkeletonLoader width={6} height={12} borderRadius={7} />
        </S.Row>
      ))}
    </>
  );

  return hasContainer ? <S.Container>{content}</S.Container> : content;
}
